import { FC } from 'react';

import { Theme, Box, TSLLink } from '@thirdspacelearning/library';

import { regionAppConfig } from '@locales';

const sx = {
    root: (theme: Theme) => ({
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        paddingTop: theme.spacing(2),
        background: theme.palette.background.default,
    }),
    link: (theme: Theme) => ({
        color: theme.palette.grey[900],
    }),
};

interface Props {}

const Footer: FC<Props> = () => {
    return (
        <Box sx={sx.root}>
            <TSLLink
                sx={sx.link}
                href={regionAppConfig.privacyPolicyUrl}
                target="_blank"
            >
                Privacy Policy
            </TSLLink>
        </Box>
    );
};

export default Footer;
